import { ErrorWrapper, ArrayIncludes } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'product.product'
const DOMAIN = {}
const REQUIRED_FIELDS = ['id']
const BASIC_FIELDS = []
const OPTS = { limit: 0, order: 'name desc' }

export class ProductsService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static async list (domain) {
    try {
      return await this.kwSearchRead(MODEL, { ...DOMAIN, ...domain }, BASIC_FIELDS, OPTS)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async read (ids, fields) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async search (domain) {
    try {
      return await this.kwSearch(MODEL, domain, BASIC_FIELDS)
    } catch (error) {
      console.log(error)
    }
  }

  static async create (data) {
    try {
      if (ArrayIncludes(REQUIRED_FIELDS, Object.keys(data))) {
        // console.log(data)
        return await this.kwCreate(MODEL, data)
      } else {
        // console.log(REQUIRED_FIELDS, Object.keys(data))

        throw new ErrorWrapper('error', 'Faltan campos')
      }
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }
}
